import * as React from "react";
import type { SVGProps } from "react";
const SvgBrandNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M2.571 2a.573.573 0 0 0-.57.571v9.715a.57.57 0 0 0 .283.502.58.58 0 0 0 .575 0 .57.57 0 0 0 .284-.502V3.143h8.571a.57.57 0 0 0 .503-.284.58.58 0 0 0 0-.575.57.57 0 0 0-.503-.284zm16 0a.57.57 0 0 0-.502.284.58.58 0 0 0 0 .575.57.57 0 0 0 .502.284h6.286v21.714h-2.286a.57.57 0 0 0-.502.284.58.58 0 0 0 0 .576.57.57 0 0 0 .502.283h2.858a.573.573 0 0 0 .571-.572V2.572A.573.573 0 0 0 25.429 2zm-3.428.571-.935 2.494L11.714 6l2.494.935.935 2.494.935-2.494L18.571 6l-2.493-.935zM6 12.286l-.935 2.493-2.494.935 2.494.935L6 19.144l.935-2.494 2.494-.935-2.494-.935zM2.563 17.99a.574.574 0 0 0-.563.58v6.857c0 .315.257.572.571.572H18a.57.57 0 0 0 .502-.284.58.58 0 0 0 0-.575.57.57 0 0 0-.502-.284H3.143v-6.286a.573.573 0 0 0-.58-.58m17.723.58-.936 2.494-2.493.935 2.494.935.935 2.494.935-2.494L23.714 22l-2.493-.935z"
    />
  </svg>
);
export default SvgBrandNewIcon;
